import { Spin, Typography } from 'antd'
import * as PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client'
import { PATIENT_MEDICAL_HISTORY } from '@dentolize/clinic-mobile/src/shared/store/queries/patientQueries'
import { MEDICALS } from '@dentolize/clinic-mobile/src/shared/store/queries/medicalQueries'
import { useUser } from '../../../../../../context/userContext'

const MedicalHistoryContent = ({ medicalHistory, patientId }) => {
  const { user } = useUser()
  const { t } = useTranslation()

  const { data, loading } = useQuery(PATIENT_MEDICAL_HISTORY, {
    variables: { patient: patientId },
    skip: !patientId || (!user.permissions.patients && !user.permissions.calendar)
  })

  const { data: medicalsData } = useQuery(MEDICALS)

  const history = medicalHistory || (data ? data.patientMedicalHistory.medicalHistory : null)

  return (
    <Spin spinning={loading}>
      {history
        ? history
            .map(medical => {
              const medicalGroup = medicalsData?.medicals.find(s => s.items.find(s => s.id === medical.medicalItemId))
              const medicalItem = medicalsData?.medicals
                .map(s => s.items)
                .flat()
                .find(s => s.id === medical.medicalItemId)

              return { medicalGroup, medicalItem, medical }
            })
            .filter(({ medicalGroup, medicalItem }) => !!medicalGroup && !!medicalItem)
            .filter(
              ({ medicalGroup, medicalItem, medical }) =>
                medicalGroup?.showAlert &&
                !((medical.status === false || medical.status === null) && medicalItem.type === 'yesNo')
            )
            .map(({ medicalItem, medical }, i) => (
              <div key={i}>
                <Typography.Text strong type={medical.status !== false && medical.status !== null ? 'danger' : 'secondary'}>
                  - {medicalItem.name}
                  {': '}
                </Typography.Text>
                {medical.details || medical.options.length || medical.checkboxes.length
                  ? medical.details
                    ? medical.details
                    : medical.options.length
                    ? medical.options.join(', ')
                    : medicalItem.options?.filter((o, i) => medical.checkboxes[i]).join(', ')
                  : medical.status
                  ? t('common.yes')
                  : t('common.no')}
              </div>
            ))
        : null}
    </Spin>
  )
}

MedicalHistoryContent.propTypes = {
  medicalHistory: PropTypes.array,
  patientId: PropTypes.string,
  placement: PropTypes.string
}

export default MedicalHistoryContent
